// extracted by mini-css-extract-plugin
export default {"vtroll":"index_vtroll_auFBb","title":"index_title_PIrFC","vask":"index_vask_cKpwx"};